export const getGradientForName = (name: string) => {
	if (!name) return '';
	// Get first two letters and convert to lowercase
	const firstTwoLetters = name.slice(0, 2).toLowerCase();

	// Generate a deterministic hash based on the first two letters
	const hash = firstTwoLetters.split('').reduce((acc, char, index) => {
		// Multiply by different primes for each position to get better distribution
		const multiplier = index === 0 ? 31 : 37;
		return char.charCodeAt(0) * multiplier + acc;
	}, 0);

	// Generate base hue (0-360)
	const hue1 = Math.abs(hash % 360);
	// Create second hue by offsetting by 60 degrees for more pronounced gradient
	const hue2 = (hue1 + 60) % 360;

	// Slightly lighter colors while maintaining saturation
	return `linear-gradient(135deg, hsl(${hue1}, 45%, 40%), hsl(${hue2}, 45%, 30%))`;
};
